/*global jQuery */
/*!
* Based on FitText.js 1.2
*
* Copyright 2011, Dave Rupert http://daverupert.com
* Released under the WTFPL license
* http://sam.zoy.org/wtfpl/
*
* Date: Thu May 05 14:23:00 2011 -0600
*/

(function ($) {
    function Dim(size, units) {
        this.size = size;
        this.units = units;
    }

    Dim.prototype = {
        multiply: function (k) {
            return new Dim(this.size * k, this.units);
        },
        plus: function (size) {
            return new Dim(this.size + size, this.units);
        },
        toString: function () {
            return '' + this.size + this.units;
        }
    };

    var parseDimRe = /([\d.]+)([\w]*)/;

    function parseDim(val) {
        var match = parseDimRe.exec(val);
        if (match) {
            return new Dim(parseFloat(match[1]), match[2]);
        } else {
            return null;
        }
    }

    // Resizer() resizes items based on the object width divided by the compressor * 10
    function fitText(el, parent, settings) {
        el.css('font-size', '');

        var h = el.outerHeight();
        var ph = parent.height();
        if (ph >= h) {
            return;
        }

        // need calculation
        var fontSize = parseDim(el.css('font-size'));
        if (fontSize === null) {
            // cannot workout this font size
            return;
        }

        function changeDirection() {
            if (h > ph) {
                return -1;
            }
            if (h / ph < settings.heightMinSpace) {
                return 1;
            }
            return 0;
        }

        var changeLimit = 10, changeSize = fontSize, change = fontSize.size, directionPrev = 0, direction = changeDirection();
        do {
            if (direction !== directionPrev) {
                change /= 1.7;
            }

            changeSize = changeSize.plus(change * direction);
            el.css('font-size', changeSize.toString());
            h = el.outerHeight();

            directionPrev = direction;
        } while (--changeLimit > 0 && (direction = changeDirection()) !== 0);

        // если мы шли вверх последний раз, то уменьшимся на полшага, на случай, если перескочили границу
        if (direction > 0) {
            changeSize = changeSize.plus(-change);
            el.css('font-size', changeSize.toString());
        }

        // $this.css('font-size', Math.max(Math.min($this.width() / (compressor * 10), parseFloat(settings.maxFontSize)), parseFloat(settings.minFontSize)));
    }

    $.fn.fitText = function (options) {
        // Setup options
        var settings = $.extend({
            minFontSize: Number.NEGATIVE_INFINITY,
            maxFontSize: Number.POSITIVE_INFINITY,
            heightMinSpace: .9
        }, options);

        return this.each(function () {
            // Store the object
            var el = $(this), parent = el.parent();

            // Call once to set.
            fitText(el, parent, settings);
        });

    };

    function fitImage(el, parent, settings) {
        var w = el.width(), pw = parent.width();
        if (w <= 0) {
            return;
        }
        var h = el.height(), ph = parent.height();
        if (h <= 0) {
            return;
        }

        var ratioW = pw / w;
        var ratioH = ph / h;
        var style = {};
        if (ratioW <= ratioH) {
            style.width = '100%';
            style.height = 'auto';
            if (settings.relativePosition) {
                style.top = (100.0 * (ph - h * ratioW) / ph / 2) + '%';
                style.position = 'relative';
            }
        } else {
            style.height = '100%';
            style.width = 'auto';
            if (settings.relativePosition) {
                style.top = 0;
            }
        }
        el.css(style);

        if (settings.show) {
            el.show();
        }
    }

    $.fn.fitImage = function (options) {
        // Setup options
        var settings = $.extend({
            heightMinSpace: .8,
            relativePosition: true,
            show: false
        }, options);

        return this.each(function () {
            // Store the object
            var el = $(this), parent = el.parent();

            var elSrc = this.src;
            if (!elSrc) {
                return;
            }

            el.one("load", function () {
                fitImage(el, parent, settings);
            }).each(function () {
                if (this.complete) {
                    $(this).trigger('load');
                }
            });
        });

    };

})(jQuery || this.jQuery || window.jQuery);
